import { SplitFactoryProvider } from '@splitsoftware/splitio-react';
import { getAccessToken } from 'helpers/auth';

export function parseJwt(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
}

type FeatureFlagsProviderProps = {
  children: React.ReactNode;
};
export const FeatureFlagsProvider = ({
  children,
}: FeatureFlagsProviderProps) => {
  const getUserSubId = () => {
    const token = getAccessToken();
    if (!token) {
      return 'unknown';
    }

    const parsedToken = parseJwt(token);
    return parsedToken.subId;
  };

  return (
    <SplitFactoryProvider
      config={{
        core: {
          authorizationKey:
            import.meta.env.VITE_SPLIT_IO_AUTHORIZATION_KEY || '',
          key: getUserSubId(),
        },
      }}
    >
      {children}
    </SplitFactoryProvider>
  );
};
